import styled, { css } from 'styled-components';
import { Input } from '../input';
import { InputLabel } from '../input/inputWithLabel/styled';
import { theme } from '../theme';
import { SufixType } from '../input/common/SufixType';

export interface SliderTrackProps {
  value: number;
  min: number;
  max: number;
}

export const thumbHeight = '1.5rem';
export const trackHeight = '0.525rem';

export const valueToPercentage = (value: number, min: number, max: number) =>
  ((value - min) / (max - min)) * 100;

export const SliderNumberInput = styled(Input)`
  width: 8.875rem;
  margin-bottom: 2rem;

  input {
    padding-left: 0.5rem;
    padding-right: ${(props) =>
      props.sufix === SufixType.Euro ? '3.6rem' : ''};

    // Chrome, Safari, Opera
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    // Firefox
    -moz-appearance: textfield;
  }
`;

export const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: aliceblue;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 0.791rem;
`;

export const SliderTrack = styled.div.attrs((props: SliderTrackProps) => ({
  style: {
    /* Slider track is one color before the currently selected value,
     * and different color after the currently selected value. */
    background: `linear-gradient(
      to right,
      ${theme.colors.primaryT1} 0%,
      ${theme.colors.primaryT1} ${valueToPercentage(
      props.value,
      props.min,
      props.max,
    )}%,
    ${theme.colors.primaryK2} ${valueToPercentage(
      props.value,
      props.min,
      props.max,
    )}%,
  ${theme.colors.primaryK2} 100%)`,
  },
}))<SliderTrackProps>`
  width: 100%;
  height: ${trackHeight};
  position: absolute;
  z-index: 1;
  border-radius: 0.3125rem;
`;

export const thumbStyle = css`
  appearance: none;
  -webkit-appearance: none;
  width: ${thumbHeight};
  height: ${thumbHeight};
  border: none;
  border-radius: 50%;
  background: ${theme.colors.primaryT1};
`;

export const SliderRangeInput = styled.input`
  width: 100%;

  -webkit-appearance: none;
  appearance: none;

  position: absolute;
  z-index: 3;

  background-color: transparent;

  // Chrome, Safari, Opera, Edge track
  &::-webkit-slider-runnable-track {
    height: ${trackHeight};
  }

  // Firefox track
  &::-moz-range-track {
    height: ${trackHeight};
  }

  // Chrome, Safari, Opera, Edge thumb
  &::-webkit-slider-thumb {
    ${thumbStyle}
    /* By default, the thumb is not centered, the correct thumb position is 
     * done by adding a top margin that is calculated as: 
     * (track height in pixels / 2) - (thumb height in pixels /2) */
    margin-top: calc(${trackHeight} / 2 - ${thumbHeight} / 2);
  }

  // Firefox thumb
  &::-moz-range-thumb {
    ${thumbStyle}
  }
`;

export const SliderNotchContainer = styled.div`
  width: 100%;
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const SliderNotch = styled.div`
  background-color: ${theme.colors.primaryW};
  width: 0.125rem;
  height: 0.375rem;
  border-radius: 0.0625rem;
`;

export const StyledSliderWithLabel = styled.div`
  width: 100%;
`;

export const StyledInputLabel = styled(InputLabel)`
  display: block;
  margin-bottom: 1.4375rem;
`;
